var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-nav"},[_c('Navigation',{attrs:{"invert":true}})],1),_c('div',{staticClass:"footer-copyright"},[_vm._v(" Copyright © 2025 Regtime, Inc. All rights reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }